import { Search } from 'lucide-react'
import { Input } from './input'
import { cn } from '@/lib/utils'
import Cross from '@/components/ui/icons/cross'

export default function SearchInput({
  value,
  onChange,
  onCancel,
  placeholder = 'Search for order number',
  helperText,
  className
}: {
  value: string
  onChange: (value: string) => void
  onCancel?: () => void
  placeholder?: string
  helperText?: string
  className?: string
}) {
  return (
    <div className={cn('flex w-full flex-col gap-1', className)}>
      <div
        data-testid='search-icon'
        className='flex w-full items-center gap-3 rounded-2xl border border-[#E9EAED] bg-white px-4 py-3 focus-within:border-[#A0A3A6]'
      >
        <Search className='min-h-5 min-w-5 text-[#4E545E]' />
        <Input
          value={value}
          className='h-6 border-none px-0 shadow-none outline-hidden placeholder:text-[#A0A3A6] focus-visible:ring-0'
          placeholder={placeholder}
          onChange={e => onChange(e.target.value)}
          autoComplete='off'
        />

        {value && (
          <button
            type='button'
            aria-label='Clear search'
            className='cursor-pointer p-1 transition-all duration-200 ease-in-out hover:bg-gray-200'
            onClick={onCancel}
          >
            <Cross className='h-3 w-3 text-black/50' />
          </button>
        )}
      </div>

      {helperText && <p className='px-4 text-xs text-custom-neutral-500'>{helperText}</p>}
    </div>
  )
}
